import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
import { ARPaymentTransferAccountDetailsRawDto } from './ar-payment-transfer-account-details-raw-dto';

export class ARPaymentTransferRawDto {
    paymentId: number;
    communityId: number;
    customerCode: string;
    managementCompanyId: number;
    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    postDate: Date;
    @Type(() => ARPaymentTransferAccountDetailsRawDto)
    transferAccounts: ARPaymentTransferAccountDetailsRawDto[];
}
